function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
import { Flex, Text } from "sprout-ui-primitives";
import { media, themeGet } from "sprout-ui-theme";
import styled from "styled-components";
const TopicPageHeaderH1Wrapper = styled(Flex)`
  align-self: stretch;

  ${media.up("medium", "pointer")} {
    position: relative;
    ::before,
    ::after {
      content: "";
      flex: 1;
      border-bottom: 1px solid ${themeGet("colors.blue.500")};
      margin-top: auto;
      margin-bottom: auto;
    }
  }
`;
const TopicPageHeaderH1ForwardedRef = /*#__PURE__*/ forwardRef(function TopicPageHeaderH1(props, ref) {
    const { beforeTitle , title  } = props, rest = _objectWithoutProperties(props, [
        "beforeTitle",
        "title"
    ]);
    return /*#__PURE__*/ _jsx(TopicPageHeaderH1Wrapper, _objectSpread({
        ref: ref
    }, rest, {
        children: /*#__PURE__*/ _jsxs(Flex, {
            alignItems: "center",
            mx: "auto",
            px: 2,
            children: [
                beforeTitle,
                title && /*#__PURE__*/ _jsx(Text, {
                    as: "h1",
                    fontWeight: "bold",
                    textAlign: "center",
                    fontSize: [
                        "34px",
                        null,
                        "45px"
                    ],
                    children: title
                })
            ]
        })
    }));
});
export default TopicPageHeaderH1ForwardedRef;
